module.exports = require('./lib/no-important.js');



//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/~/aphrodite/no-important.js
// module id = 832
// module chunks = 5